import { useAuthStore } from './authStore'

/** True when the access token is missing, expired, or within the refresh buffer. */
export function isAccessTokenStale(bufferMs = 60_000): boolean {
  const { accessToken, expiresAtMs } = useAuthStore.getState()
  if (!accessToken) return true
  if (!expiresAtMs) return false
  return Date.now() >= expiresAtMs - bufferMs
}
